<template>
  <ValidationObserver v-slot="{ valid }">
    <unicom-filtro-v2
      titulo="Filtrar PTU"
      :value="mostrar"
      @limpar-filtro="limpar"
      @fechar="fecharFiltro"
      @filtrar="filtrar"
      :bloquearBotaoFiltro="!valid"
    >
      <div slot="corpo-subtitulo">
        Selecione os dados desejados,<br />
        depois clique em FILTRAR.
      </div>
      <div slot="corpo-filtro" style="margin: 0 32px">
        <unicom-linha espacamento class="fonte-secundaria espacamento-filtro">
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Status"
              titulo="Status"
              v-model="objetoFiltro.status.descricao"
              @index="index => selecionarChave(index, 'status', listaStatus)"
              :items="listaStatus.map(e => e.descricao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Todas as Unimeds"
              titulo="Unimed Origem"
              v-model="objetoFiltro.unimedOrigem.descricao"
              @index="selecionarUnimed"
              :items="listaUnimedOrigem.map(e => e.textoExibicao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Tipo Atuação"
              titulo="Tipo Atuação"
              v-model="objetoFiltro.tipoAtuacao.descricao"
              @index="
                index => selecionarChave(index, 'tipoAtuacao', listaTipoAtuacao)
              "
              :items="listaTipoAtuacao.map(e => e.descricao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Selecione um tipo"
              titulo="Tipo"
              v-model="objetoFiltro.tipo.descricao"
              @index="index => selecionarChave(index, 'tipo', listaTipos)"
              :items="listaTipos.map(e => e.descricao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Selecione uma rede"
              titulo="Rede"
              v-model="objetoFiltro.rede.descricao"
              @index="index => selecionarChave(index, 'rede', listaRedes)"
              :items="listaRedes.map(e => e.descricao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Selecione um analista"
              titulo="Analista responsável"
              v-model="objetoFiltro.analistaResponsavel.descricao"
              @index="
                index =>
                  selecionarChave(
                    index,
                    'analistaResponsavel',
                    listaAnalistas,
                    'id'
                  )
              "
              :items="listaAnalistas.map(e => e.nome)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-campo-texto
              maxCaracteres="60"
              :icone="objetoFiltro.documento ? 'x' : ''"
              ladoIcone="direito"
              clickIcone
              @click-icone="objetoFiltro.documento = ''"
              colorPlaceholder="#9E9E9E"
              placeholder="Escreva um CPF ou CNPJ"
              titulo="CPF/CNPJ"
              v-model="objetoFiltro.documento"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-campo-texto
              maxCaracteres="60"
              :icone="objetoFiltro.nomePrestador ? 'x' : ''"
              ladoIcone="direito"
              clickIcone
              @click-icone="objetoFiltro.nomePrestador = ''"
              colorPlaceholder="#9E9E9E"
              placeholder="Escreva o nome do prestador"
              titulo="Nome do prestador"
              v-model="objetoFiltro.nomePrestador"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <ValidationProvider
              :rules="{ regex: /^[0-9]+$/ }"
              :customMessages="{
                regex: 'Esse campo aceita apenas números.'
              }"
              v-slot="{ errors }"
            >
              <unicom-campo-texto
                maxCaracteres="8"
                :icone="objetoFiltro.codigoPrestador ? 'x' : ''"
                ladoIcone="direito"
                clickIcone
                @click-icone="objetoFiltro.codigoPrestador = ''"
                colorPlaceholder="#9E9E9E"
                placeholder="Escreva o código do prestador"
                titulo="Código do prestador"
                v-model="objetoFiltro.codigoPrestador"
                :mensagemErro="errors[0]"
              />
            </ValidationProvider>
          </unicom-coluna>
          <unicom-coluna
            sm="12"
            class="linha-embaixo"
            v-if="habilitarFiltroIntercambio"
          >
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Atende Intercâmbio alterado"
              titulo="ID_INTERCÂMBIO"
              v-model="objetoFiltro.atendeIntercambio.descricao"
              @index="
                index =>
                  selecionarChave(
                    index,
                    'atendeIntercambio',
                    listaTipoAtendeIntercambio
                  )
              "
              :items="listaTipoAtendeIntercambio.map(e => e.descricao)"
            />
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-filtro-v2>
  </ValidationObserver>
</template>

<script>
/* eslint-disable */
import FiltroMixin from "@/shared/mixin/FiltroMixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  mixins: [FiltroMixin],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    listaAnalistas: {
      type: Array,
      default: () => []
    },
    listaTipoAtendeIntercambio: {
      type: Array,
      default: () => []
    },
    listaStatus: {
      type: Array,
      default: () => []
    },
    listaUnimedOrigem: {
      type: Array,
      default: () => []
    },
    listaTipos: {
      type: Array,
      default: () => []
    },
    listaRedes: {
      type: Array,
      default: () => []
    },
    listaTipoAtuacao: {
      type: Array,
      default: () => []
    },
    limparUnimed: {
      type: Boolean,
      default: false
    },
    habilitarFiltroIntercambio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      objetoFiltro: {},
      objetoFiltroVazio: {
        atendeIntercambio: {
          chave: "",
          descricao: ""
        },
        atendeIntercambioAnterior: {
          chave: "",
          descricao: ""
        },
        status: {
          chave: "",
          descricao: ""
        },
        unimedOrigem: {
          chave: "",
          descricao: ""
        },
        tipo: {
          chave: "",
          descricao: ""
        },
        rede: {
          chave: "",
          descricao: ""
        },
        tipoAtuacao: {
          chave: "",
          descricao: ""
        },
        documento: "",
        nomePrestador: "",
        codigoPrestador: "",
        analistaResponsavel: {
          chave: "",
          descricao: ""
        }
      }
    };
  },
  beforeMount() {
    this.objetoFiltro = JSON.parse(JSON.stringify(this.objetoFiltroVazio));
  },
  methods: {
    selecionarUnimed(index) {
      this.selecionarChave(index, "unimedOrigem", this.listaUnimedOrigem, "id");
      this.$emit("limpar-pesquisa");
    },
    filtrar() {
      const {
        atendeIntercambio: { chave: chaveAtendeIntercambio },
        status: { chave: chaveStatus },
        unimedOrigem: { chave: chaveUnimedOrigem },
        tipo: { chave: chaveTipo },
        rede: { chave: chaveRede },
        tipoAtuacao: { chave: chaveTipoAtuacao },
        documento,
        nomePrestador,
        codigoPrestador,
        analistaResponsavel: { chave: chaveAnalistaResponsavel }
      } = this.objetoFiltro;

      const objetoFiltro = {
        codigo: codigoPrestador,
        cpfCnpj: documento.replace(/[^A-Za-z0-9]/g, "").toUpperCase(),
        idAnalista: chaveAnalistaResponsavel,
        nome: nomePrestador,
        rede: chaveRede,
        status: chaveStatus,
        tipoAtuacao: chaveTipoAtuacao,
        unimedOrigem: chaveUnimedOrigem,
        tipo: chaveTipo,
        atendeIntercambio: chaveAtendeIntercambio === "" ? "" : chaveAtendeIntercambio === "SIM" ? "SIM" : "NAO",
        intercambioVirouNao: chaveAtendeIntercambio === "ALTERADO" ? true : ""
      };

      this.$emit("filtrar", objetoFiltro);
      this.$emit("filtroPuro", this.objetoFiltro);
    }
  },
  watch: {
    limparUnimed() {
      if (this.limparUnimed) {
        // this.objetoFiltro.unimedOrigem = {
        //   chave: "",
        //   descricao: ""
        // };
        // this.$emit("unimed-limpada");
      }
    }
  }
};
</script>

<style lang="scss">
.espacamento-filtro {
  .col-12 {
    padding-top: 24px;
  }
}
</style>
